import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './SectionTag';
import { BONOS } from './salesData';
import { HERO_IMAGE_URL } from '../utils/headMeta';
const SUMMARY = ['100 recetas', '2 tomos', '5 bonos', 'Acceso inmediato'];

/**
 * STACK COMPLETO, en versión compacta: acá no se vuelve a explicar el
 * producto, solo se ve de una sola vez todo lo que entra en el kit.
 */
export function TomosSection() {
  return <section className="overflow-hidden bg-ivory py-11 sm:py-14" aria-labelledby="tomos-title" data-id="element-359" data-mp="xdyw1t275m8s">
      <div className="mx-auto w-full max-w-5xl px-5 sm:px-8" data-id="element-360" data-mp="11ehonpbwywc1">
        <div className="text-center" data-id="element-361" data-mp="16cj5e3lvajkc">
          <div className="flex justify-center" data-id="element-362" data-mp="16bhnbf6fowt4">
            <SectionTag data-id="element-363" data-mp="1bbvr2l105klc">El kit completo</SectionTag>
          </div>
          <h2 id="tomos-title" className="mt-3 font-display text-[1.6rem] leading-tight text-charcoal sm:text-[2.2rem]" data-id="element-364" data-mp="1ba2mdb9y9afz">
            Todo lo que necesitás para empezar con tus New York Cookies
          </h2>
        </div>

        <div className="mt-6 grid items-center gap-6 sm:grid-cols-2 sm:gap-8" data-id="element-365" data-mp="2qn7afjnbxe31">
          <img src={HERO_IMAGE_URL} alt="Los dos tomos de 100 New York Cookies con la colección de cookies delante." loading="lazy" decoding="async" className="animate-breathe mx-auto max-h-[230px] w-full object-contain drop-shadow-[0_22px_38px_rgba(51,39,34,0.22)] sm:max-h-[300px]" data-id="element-366" data-mp="2mm3vczd3vm2v" />

          <motion.ul initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="grid grid-cols-5 gap-2 sm:gap-3" data-id="element-367" data-mp="27rh45k8d5vjc">
            {BONOS.map(bono => <li key={bono.id} data-id="element-368" data-mp="1ozeks14c815e">
                <img src={bono.image} alt={`Portada del ${bono.label}: ${bono.title}.`} loading="lazy" decoding="async" className="aspect-[3/4] w-full rounded-lg bg-cream object-contain shadow-bakery-sm" data-id="element-369" data-mp="1oxk10q4syf2w" />
              </li>)}
          </motion.ul>
        </div>

        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 border-t border-warm pt-5" data-id="element-370" data-mp="11c9iks162kv7">
          {SUMMARY.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-371" data-mp="15ewfh7cp2vz9" data-mpi={index}>
              {index > 0 && <span className="font-sans text-[0.7rem] text-caramel" aria-hidden data-id="element-372" data-mp="1t50awrfqbpf6">
                  ·
                </span>}
              <span className="font-sans text-[0.68rem] font-bold uppercase tracking-[0.1em] text-charcoal sm:text-[0.8rem]" data-id="element-373" data-mp="1k9asmr9kvb60">
                {item}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}